import { Select } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

type UserRole = 'owner' | 'admin' | 'recruiter' | 'viewer';

interface RoleSelectorProps {
  value: UserRole;
  onChange: (role: UserRole) => void;
  disabled?: boolean;
  excludeOwner?: boolean;
  label?: string;
}

const roleDescriptions: Record<UserRole, string> = {
  owner: 'Acesso total incluindo faturamento e exclusão da organização',
  admin: 'Gerenciar vagas, candidatos e convidar usuários',
  recruiter: 'Criar e editar vagas, avaliar candidatos',
  viewer: 'Acesso somente leitura a vagas e relatórios',
};

const roleLabels: Record<UserRole, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  recruiter: 'Recrutador',
  viewer: 'Visualizador',
};

export function RoleSelector({
  value,
  onChange,
  disabled,
  excludeOwner,
  label = 'Função',
}: RoleSelectorProps) {
  const roles: UserRole[] = excludeOwner
    ? ['admin', 'recruiter', 'viewer']
    : ['owner', 'admin', 'recruiter', 'viewer'];

  return (
    <div className="space-y-2">
      <Label htmlFor="role">{label}</Label>
      <Select
        id="role"
        value={value}
        onChange={(e) => onChange(e.target.value as UserRole)}
        disabled={disabled}
      >
        {roles.map((role) => (
          <option key={role} value={role} title={roleDescriptions[role]}>
            {roleLabels[role]}
          </option>
        ))}
      </Select>
      <p className="text-xs text-muted-foreground">
        {roleDescriptions[value]}
      </p>
    </div>
  );
}
